/* AIRE — Étagère 3D sur mesure pour pegboard : noyau + interface montable (2026-10-22).
 *
 * window.ETAG (noyau, sans DOM) : dimensions, clé (encode / decode), trous de goupille, volume de matière,
 *   prix, résumé de la ligne panier, dessins SVG (aperçu, vignette du configurateur).
 * ETAG.mount(el, opts) : interface (largeur, profondeur, rebord, couleur, aperçu, prix).
 *   opts.state    : état de départ { w, d (mm), rim (bool), color }
 *   opts.onChange : appelé à chaque modification avec (état, valide)
 *   opts.priceFor : fonction(état) -> texte de prix affiché (sinon prix de base en €)
 *   opts.lang     : fr | en | de | es | it | nl (sinon window.ETAG_LANG, sinon <html lang>)
 *
 * Géométrie relevée sur les modèles de Roman (Corps1.stl 150 × 60, Corps2_avec_rebord.stl 150 × 80) :
 *   plateau 15 mm ; coins avant R 15 ; chanfreins 0,5 mm sur les arêtes externes ;
 *   rebord (avant + côtés) 4 mm d'épaisseur, 7 mm au-dessus du plateau (22 mm au total), congé R 5 à l'intérieur ;
 *   2 trous de goupille Ø 6,2 × 28 mm depuis l'arrière, axe à 7,5 mm de haut, entrée chanfreinée Ø 7 ;
 *   logo « a. » gravé 1 mm sur le flanc droit, près de l'arrière.
 * Prix : affine en volume de matière, 7,90 € (8 × 4 cm sans rebord) → 79 € (33 × 33 cm avec rebord), au 0,10 € près.
 *
 * Utilisé par : snippets/etagere-fiche.liquid + assets/etagere-fiche.js (fiche produit),
 *               assets/pegconf-etagere.js (configurateur de pegboard),
 *               snippets/etagere-generateur.liquid + assets/etagere-stl.js (page atelier : clé -> STL).
 */
(function (root) {
  "use strict";
  var prev = root.ETAG;
  if (prev && prev.mount) return;

  /* ================= cotes (mm) ================= */
  var G = {
    T: 15, RIM_H: 7, RIM_W: 4, FILLET: 5, R: 15, CH: 0.5,
    HOLE_D: 6.2, HOLE_DEPTH: 28, HOLE_Z: 7.5, HOLE_ENTRY_D: 7, HOLE_CH: 0.4,
    LOGO_DEPTH: 1,
    W_MIN: 80, W_MAX: 330, D_MIN: 40, D_MAX: 330, STEP: 10, /* pas de 1 cm (Roman, 22/10) */
    HOLE_SPAN_MAX: 120, /* écart maximal des goupilles : retrait du PLA après impression (Roman, 22/10) */
    PRICE_MIN: 790, PRICE_MAX: 7900, PRICE_STEP: 10,
    UNIT_EUR_CENTS: 10, /* facturation « quantité × article 0,10 € », comme le pegboard sur mesure (22/10) */
    PIN: 30 /* trame du pegboard */
  };
  /* logo « a. » (contours relevés sur Corps1.stl) : u = distance depuis l'arrière, v = hauteur ; centré à 7,5 mm */
  var LOGO = [[[15.807,10.042],[15.619,10.182],[15.326,10.32],[14.998,10.419],[14.634,10.478],[13.927,10.487],[13.614,10.452],[13.315,10.384],[13.046,10.268],[12.925,10.191],[12.766,10.045],[12.631,9.868],[12.535,9.645],[12.48,9.381],[12.47,9.176],[12.5,8.924],[12.572,8.753],[12.685,8.615],[12.939,8.445],[13.094,8.378],[13.668,8.234],[15.144,8.007],[16.136,7.776],[16.372,7.699],[16.802,7.495],[17.176,7.225],[17.408,6.968],[17.603,6.67],[17.705,6.44],[17.777,6.178],[17.82,5.886],[17.835,5.564],[17.783,5.009],[17.719,4.764],[17.628,4.542],[17.384,4.159],[17.067,3.858],[16.781,3.684],[16.463,3.545],[16.229,3.474],[15.732,3.382],[15.208,3.352],[14.8,3.369],[14.407,3.423],[14.028,3.511],[13.663,3.636],[13.317,3.801],[12.993,4.011],[12.69,4.266],[12.41,4.566],[12.38,4.199],[12.293,3.9],[12.242,3.8],[12.11,3.636],[11.857,3.463],[11.545,3.369],[11.021,3.364],[10.77,3.402],[10.552,3.464],[10.363,3.552],[10.363,4.563],[10.763,4.501],[10.958,4.531],[11.095,4.642],[11.148,4.838],[11.178,5.39],[11.194,9.8],[11.243,10.096],[11.325,10.36],[11.439,10.59],[11.581,10.794],[11.743,10.973],[11.927,11.128],[12.131,11.258],[12.587,11.455],[13.092,11.572],[13.623,11.63],[14.492,11.641],[15.126,11.571],[15.714,11.43],[16.114,11.266],[16.48,11.057],[16.699,10.887],[16.895,10.694],[17.068,10.476],[17.218,10.235],[17.34,9.967],[17.432,9.67],[17.494,9.345],[17.525,8.99],[16.219,8.99],[16.164,9.394],[16.112,9.569],[15.962,9.867]],[[12.494,6.152],[12.486,7.625],[12.772,7.466],[13.132,7.357],[14.853,7.096],[15.277,7.006],[15.653,6.875],[15.822,6.79],[16.11,6.572],[16.282,6.364],[16.365,6.196],[16.438,5.897],[16.452,5.665],[16.419,5.369],[16.32,5.122],[16.17,4.921],[15.982,4.763],[15.757,4.645],[15.498,4.565],[15.215,4.519],[14.915,4.503],[14.315,4.547],[14.05,4.602],[13.589,4.772],[13.39,4.877],[13.055,5.122],[12.801,5.401],[12.703,5.549],[12.563,5.858]],[[8.444,8.262],[8.567,8.037],[8.644,7.788],[8.672,7.521],[8.645,7.254],[8.567,7.005],[8.445,6.78],[8.283,6.584],[8.087,6.422],[7.862,6.3],[7.613,6.223],[7.346,6.196],[7.079,6.223],[6.83,6.301],[6.605,6.423],[6.408,6.585],[6.246,6.781],[6.124,7.006],[6.047,7.255],[6.02,7.521],[6.047,7.788],[6.124,8.037],[6.246,8.262],[6.408,8.458],[6.604,8.62],[6.829,8.742],[7.078,8.82],[7.345,8.847],[7.612,8.82],[7.861,8.742],[8.086,8.62],[8.282,8.458]]];

  /* ================= couleurs (mêmes clés que les fleurs) ================= */
  var PLA = [
    ["noir", "Noir", "#161616"], ["blanc", "Blanc", "#FFFFFF"], ["beige", "Beige", "#E7D9B0"],
    ["bleu", "Bleu", "#255ACC"], ["rouge", "Rouge", "#E23B30"], ["vert", "Vert", "#4CA74C"],
    ["vert-fonce", "Vert foncé", "#2C672D"], ["jaune", "Jaune", "#FBE64D"], ["orange", "Orange", "#F09035"],
    ["violet", "Violet", "#9A52C8"], ["sauge", "Vert sauge", "#AFCDB6"], ["bleu-ciel", "Bleu ciel", "#D2EAF1"]
  ];
  var COL = {}; PLA.forEach(function (p) { COL[p[0]] = p; });

  /* ================= textes (6 langues) ================= */
  var LANGS = {
    fr: { w: "Largeur", d: "Profondeur", rim: "Rebord", rimOn: "Avec rebord", rimOff: "Sans rebord", color: "Couleur",
          cm: "cm", pins: "2 goupilles inox incluses", wall: "Côté mur", front: "Avant", prop: ["Étagère", "Clé étagère"],
          sumRim: "avec rebord", sumFlat: "sans rebord", range: "de {a} à {b} cm", thick: "Épaisseur {t} mm",
          col: { noir: "Noir", blanc: "Blanc", beige: "Beige", bleu: "Bleu", rouge: "Rouge", vert: "Vert", "vert-fonce": "Vert foncé", jaune: "Jaune", orange: "Orange", violet: "Violet", sauge: "Vert sauge", "bleu-ciel": "Bleu ciel" } },
    en: { w: "Width", d: "Depth", rim: "Lip", rimOn: "With lip", rimOff: "No lip", color: "Colour",
          cm: "cm", pins: "2 stainless steel pins included", wall: "Wall side", front: "Front", prop: ["Shelf", "Shelf key"],
          sumRim: "with lip", sumFlat: "no lip", range: "{a} to {b} cm", thick: "{t} mm thick",
          col: { noir: "Black", blanc: "White", beige: "Beige", bleu: "Blue", rouge: "Red", vert: "Green", "vert-fonce": "Dark green", jaune: "Yellow", orange: "Orange", violet: "Purple", sauge: "Sage green", "bleu-ciel": "Sky blue" } },
    de: { w: "Breite", d: "Tiefe", rim: "Rand", rimOn: "Mit Rand", rimOff: "Ohne Rand", color: "Farbe",
          cm: "cm", pins: "2 Edelstahlstifte inklusive", wall: "Wandseite", front: "Vorne", prop: ["Regal", "Regalschlüssel"],
          sumRim: "mit Rand", sumFlat: "ohne Rand", range: "{a} bis {b} cm", thick: "{t} mm stark",
          col: { noir: "Schwarz", blanc: "Weiß", beige: "Beige", bleu: "Blau", rouge: "Rot", vert: "Grün", "vert-fonce": "Dunkelgrün", jaune: "Gelb", orange: "Orange", violet: "Violett", sauge: "Salbeigrün", "bleu-ciel": "Himmelblau" } },
    es: { w: "Ancho", d: "Fondo", rim: "Borde", rimOn: "Con borde", rimOff: "Sin borde", color: "Color",
          cm: "cm", pins: "2 clavijas de acero inoxidable incluidas", wall: "Lado pared", front: "Delante", prop: ["Estante", "Clave del estante"],
          sumRim: "con borde", sumFlat: "sin borde", range: "de {a} a {b} cm", thick: "Grosor {t} mm",
          col: { noir: "Negro", blanc: "Blanco", beige: "Beige", bleu: "Azul", rouge: "Rojo", vert: "Verde", "vert-fonce": "Verde oscuro", jaune: "Amarillo", orange: "Naranja", violet: "Violeta", sauge: "Verde salvia", "bleu-ciel": "Azul cielo" } },
    it: { w: "Larghezza", d: "Profondità", rim: "Bordo", rimOn: "Con bordo", rimOff: "Senza bordo", color: "Colore",
          cm: "cm", pins: "2 perni in acciaio inox inclusi", wall: "Lato muro", front: "Davanti", prop: ["Mensola", "Chiave mensola"],
          sumRim: "con bordo", sumFlat: "senza bordo", range: "da {a} a {b} cm", thick: "Spessore {t} mm",
          col: { noir: "Nero", blanc: "Bianco", beige: "Beige", bleu: "Blu", rouge: "Rosso", vert: "Verde", "vert-fonce": "Verde scuro", jaune: "Giallo", orange: "Arancione", violet: "Viola", sauge: "Verde salvia", "bleu-ciel": "Azzurro" } },
    nl: { w: "Breedte", d: "Diepte", rim: "Rand", rimOn: "Met rand", rimOff: "Zonder rand", color: "Kleur",
          cm: "cm", pins: "2 rvs pennen inbegrepen", wall: "Muurzijde", front: "Voorkant", prop: ["Plank", "Plankcode"],
          sumRim: "met rand", sumFlat: "zonder rand", range: "{a} tot {b} cm", thick: "{t} mm dik",
          col: { noir: "Zwart", blanc: "Wit", beige: "Beige", bleu: "Blauw", rouge: "Rood", vert: "Groen", "vert-fonce": "Donkergroen", jaune: "Geel", orange: "Oranje", violet: "Paars", sauge: "Saliegroen", "bleu-ciel": "Hemelsblauw" } }
  };
  function normLang(l) {
    l = String(l || "").slice(0, 2).toLowerCase();
    return LANGS[l] ? l : (l ? "en" : "fr");
  }
  function pageLang() {
    var l = root.ETAG_LANG || (root.document && root.document.documentElement.getAttribute("lang")) || "fr";
    return normLang(l);
  }
  function T(lang) { return LANGS[normLang(lang || pageLang())] || LANGS.fr; }
  function colName(k, lang) { var c = T(lang).col; return (c && c[k]) || (COL[k] ? COL[k][1] : k); }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k]; }); }
  function cmTxt(mm, lang) {
    var v = Math.round(mm) / 10, s = (v % 1 === 0) ? String(v) : v.toFixed(1);
    return normLang(lang || pageLang()) === "en" ? s : s.replace(".", ",");
  }

  /* ================= état ================= */
  function snap(v, lo, hi) {
    v = Math.round((Number(v) || 0) / G.STEP) * G.STEP;
    return Math.max(lo, Math.min(hi, v));
  }
  function normalize(st) {
    st = st || {};
    return {
      w: snap(st.w != null ? st.w : 250, G.W_MIN, G.W_MAX),
      d: snap(st.d != null ? st.d : 150, G.D_MIN, G.D_MAX),
      rim: !!st.rim,
      color: COL[st.color] ? st.color : "blanc"
    };
  }
  function clone(st) { return normalize(st); }
  function isValid(st) {
    if (!st) return false;
    var n = normalize(st);
    return n.w === Number(st.w) && n.d === Number(st.d) && !!COL[st.color];
  }
  /* clé de commande : E1.<largeur mm>.<profondeur mm>.<r|p>.<couleur> (ex. E1.250.150.r.bleu) */
  function encode(st) {
    var n = normalize(st);
    return "E1." + n.w + "." + n.d + "." + (n.rim ? "r" : "p") + "." + n.color;
  }
  function decode(key) {
    var m = String(key || "").trim().match(/^E1\.(\d{2,3})\.(\d{2,3})\.([rp])\.([a-z-]+)$/);
    if (!m) return null;
    var st = { w: +m[1], d: +m[2], rim: m[3] === "r", color: m[4] };
    return isValid(st) ? normalize(st) : null;
  }

  /* ================= trous de goupille =================
     Écart multiple de 60 mm (trame 30), centré : 60 mm jusqu'à 17 cm de large (15 cm -> 60, comme Corps1),
     120 mm à partir de 18 cm ; jamais plus de 120 mm (HOLE_SPAN_MAX) : au-delà, le retrait du PLA
     après impression risque d'empêcher les goupilles d'entrer dans le pegboard. */
  function holeSpacing(w) {
    if (w < 120) return 60;
    return Math.min(G.HOLE_SPAN_MAX, Math.max(60, Math.floor((w - 60) / 60) * 60));
  }
  function holes(st) {
    var n = normalize(st), s = holeSpacing(n.w);
    return [n.w / 2 - s / 2, n.w / 2 + s / 2];
  }
  function height(st) { return G.T + (normalize(st).rim ? G.RIM_H : 0); }

  /* ================= volume de matière (mm³) =================
     Intégrale de l'aire des sections horizontales (Simpson, exacte sur les chanfreins).
     Aire d'un rectangle W × D, coins avant arrondis R, rentré de c sur les côtés et l'avant, de cb à l'arrière. */
  var K = 2 * (1 - Math.PI / 4);
  function area(w, d, c, cb) { var r = Math.max(G.R - c, 0); return (w - 2 * c) * (d - c - cb) - K * r * r; }
  function simpson(f, a, b, n) {
    n = n || 2; if (n % 2) n++;
    var h = (b - a) / n, s = f(a) + f(b), i;
    for (i = 1; i < n; i++) s += f(a + i * h) * (i % 2 ? 4 : 2);
    return s * h / 3;
  }
  var HOLES_VOL = (function () {
    var r = G.HOLE_D / 2, r0 = G.HOLE_ENTRY_D / 2, h = G.HOLE_CH;
    return Math.PI * r * r * (G.HOLE_DEPTH - h) + Math.PI * h / 3 * (r0 * r0 + r0 * r + r * r);
  })();
  var LOGO_VOL = 0; /* calculé après chargement des contours */
  function volume(st) {
    var n = normalize(st), W = n.w, D = n.d, c = G.CH, v;
    if (!n.rim) {
      /* plateau 15 mm, chanfreins dessus / dessous tout autour (arrière compris, comme Corps1) */
      v = simpson(function (z) { var k = c - z; return area(W, D, k, k); }, 0, c)
        + area(W, D, 0, 0) * (G.T - 2 * c)
        + simpson(function (z) { var k = z - (G.T - c); return area(W, D, k, k); }, G.T - c, G.T);
    } else {
      /* bloc 22 mm (arrière sans chanfrein, comme Corps2) moins l'intérieur du rebord au-dessus du plateau */
      var H = G.T + G.RIM_H, Rw = G.RIM_W, F = G.FILLET;
      v = simpson(function (z) { return area(W, D, c - z, 0); }, 0, c)
        + area(W, D, 0, 0) * (H - 2 * c)
        + simpson(function (z) { return area(W, D, z - (H - c), 0); }, H - c, H);
      /* intérieur : congé (z de 15 à 20), paroi droite, chanfrein du haut (rentré de 4 -> 3,5) */
      var cut = function (dd) { return (W - 2 * dd) * (D - dd) - K * Math.pow(G.R - dd, 2); };
      v -= simpson(function (z) { return cut(Rw + F - Math.sqrt(Math.max(0, F * F - Math.pow(G.T + F - z, 2)))); }, G.T, G.T + F, 400);
      v -= cut(Rw) * (H - c - (G.T + F));
      v -= simpson(function (z) { return cut(Rw - (z - (H - c))); }, H - c, H);
    }
    return v - 2 * HOLES_VOL - LOGO_VOL;
  }

  /* ================= prix (centimes d'euro, TTC, tarif de base) ================= */
  var V_MIN = 0, V_MAX = 0;
  function initPrice() {
    V_MIN = volume({ w: G.W_MIN, d: G.D_MIN, rim: false });
    V_MAX = volume({ w: G.W_MAX, d: G.D_MAX, rim: true });
  }
  function priceCents(st) {
    var v = volume(st), t = (v - V_MIN) / (V_MAX - V_MIN);
    var p = G.PRICE_MIN + t * (G.PRICE_MAX - G.PRICE_MIN);
    p = Math.round(p / G.PRICE_STEP) * G.PRICE_STEP;
    return Math.max(G.PRICE_MIN, Math.min(G.PRICE_MAX, p));
  }
  function euros(cents, lang) {
    var s = (cents / 100).toFixed(2);
    return normLang(lang || pageLang()) === "en" ? "€" + s : s.replace(".", ",") + " €";
  }
  /* quantité de l'article « unité » (0,10 € en base) à mettre au panier pour une étagère */
  function unitQty(st) { return Math.round(priceCents(st) / G.UNIT_EUR_CENTS); }

  /* ================= résumé (ligne panier) ================= */
  function summary(st, lang) {
    var n = normalize(st), L = T(lang);
    return cmTxt(n.w, lang) + " × " + cmTxt(n.d, lang) + " " + L.cm + " · " + (n.rim ? L.sumRim : L.sumFlat) + " · " + colName(n.color, lang);
  }

  /* ================= dessin ================= */
  function shade(hex, f) {
    var h = hex.replace("#", ""), r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    var m = function (x) { return Math.max(0, Math.min(255, Math.round(f < 0 ? x * (1 + f) : x + (255 - x) * f))); };
    return "#" + [m(r), m(g), m(b)].map(function (x) { return ("0" + x.toString(16)).slice(-2); }).join("");
  }
  /* contour (plan) : x de 0 à W, y = distance depuis le mur (0 = mur, D = avant) ; rentré c (côtés, avant), cb (mur) */
  function outline(W, D, c, cb, seg) {
    var r = Math.max(G.R - c, 0.01), pts = [], i, a;
    seg = seg || 10;
    pts.push([c, cb]); pts.push([W - c, cb]);
    for (i = 0; i <= seg; i++) { a = (i / seg) * Math.PI / 2; pts.push([W - G.R + r * Math.cos(a), D - G.R + r * Math.sin(a)]); }
    for (i = 0; i <= seg; i++) { a = Math.PI / 2 + (i / seg) * Math.PI / 2; pts.push([G.R + r * Math.cos(a), D - G.R + r * Math.sin(a)]); }
    return pts;
  }
  /* projection orthographique : lacet (yaw) autour de la verticale, puis plongée (pitch).
     Vue « FRONT » (vignette du configurateur) : de face, un peu de dessus ; vue « 3/4 » (aperçu). */
  var VIEW_FRONT = { yaw: 0, pitch: 30 }, VIEW_34 = { yaw: 12, pitch: 38 };
  function projector(v) {
    var ct = Math.cos(v.yaw * Math.PI / 180), stt = Math.sin(v.yaw * Math.PI / 180);
    var cp = Math.cos(v.pitch * Math.PI / 180), sp = Math.sin(v.pitch * Math.PI / 180);
    return function (x, d, z) { return [x * ct + d * stt, -z * cp + (d * ct - x * stt) * sp]; };
  }
  function hull(pts) {
    pts = pts.slice().sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
    var cr = function (o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); };
    var lo = [], up = [], i;
    for (i = 0; i < pts.length; i++) { while (lo.length >= 2 && cr(lo[lo.length - 2], lo[lo.length - 1], pts[i]) <= 0) lo.pop(); lo.push(pts[i]); }
    for (i = pts.length - 1; i >= 0; i--) { while (up.length >= 2 && cr(up[up.length - 2], up[up.length - 1], pts[i]) <= 0) up.pop(); up.push(pts[i]); }
    up.pop(); lo.pop(); return lo.concat(up);
  }
  function pathOf(pts) { return "M" + pts.map(function (p) { return p[0].toFixed(2) + " " + p[1].toFixed(2); }).join("L") + "Z"; }
  function bbox(pts) { return pts.reduce(function (b, p) { return [Math.min(b[0], p[0]), Math.min(b[1], p[1]), Math.max(b[2], p[0]), Math.max(b[3], p[1])]; }, [1e9, 1e9, -1e9, -1e9]); }

  /* étagère dessinée (polygones SVG) ; P = projection */
  function drawing(st, P) {
    var n = normalize(st), W = n.w, D = n.d, H = height(n), hex = COL[n.color][2];
    var proj = function (poly, z) { return poly.map(function (p) { return P(p[0], p[1], z); }); };
    var dark = n.color === "noir", light = ["blanc", "bleu-ciel", "beige", "jaune", "sauge"].indexOf(n.color) >= 0;
    var top = shade(hex, dark ? 0.14 : 0.05), front = shade(hex, dark ? 0.03 : -0.12), side = shade(hex, dark ? 0.08 : -0.22);
    var edge = shade(hex, dark ? 0.34 : (light ? -0.3 : -0.4)), inner = shade(hex, dark ? 0.06 : -0.2);
    var out = outline(W, D, 0, 0, 14), parts = [], k;
    /* silhouette (contour du bas + contour du haut) = face avant ; flanc gauche ; dessus */
    var sil = hull(proj(out, 0).concat(proj(out, H)));
    parts.push('<path d="' + pathOf(sil) + '" fill="' + front + '" stroke="' + edge + '" stroke-width="0.7" stroke-linejoin="round"/>');
    if (P(1, 0, 0)[0] - P(0, 0, 0)[0] < 0.999) {
      var lf = [P(0, 0, 0), P(0, D - G.R, 0)];
      for (k = 0; k <= 8; k++) { var aa = Math.PI + (k / 8) * Math.PI / 2; lf.push(P(G.R + G.R * Math.cos(aa), D - G.R - G.R * Math.sin(aa), 0)); }
      for (k = 8; k >= 0; k--) { var ab = Math.PI + (k / 8) * Math.PI / 2; lf.push(P(G.R + G.R * Math.cos(ab), D - G.R - G.R * Math.sin(ab), H)); }
      lf.push(P(0, 0, H));
      parts.push('<path d="' + pathOf(lf) + '" fill="' + side + '" stroke="' + edge + '" stroke-width="0.5" stroke-linejoin="round"/>');
    }
    var topPoly = proj(out, H);
    parts.push('<path d="' + pathOf(topPoly) + '" fill="' + top + '" stroke="' + edge + '" stroke-width="0.7" stroke-linejoin="round"/>');
    if (n.rim) {
      /* ouverture du rebord (parois intérieures), plateau vu à travers l'ouverture, ombre du congé */
      var Rw = G.RIM_W, id = "etc" + Math.random().toString(36).slice(2, 8);
      var openTop = proj(innerOutline(W, D, Rw), H);
      parts.push('<clipPath id="' + id + '"><path d="' + pathOf(openTop) + '"/></clipPath>');
      parts.push('<path d="' + pathOf(openTop) + '" fill="' + inner + '"/>');
      parts.push('<g clip-path="url(#' + id + ')">' +
        '<path d="' + pathOf(proj(innerOutline(W, D, Rw + G.FILLET * 0.3), G.T + G.FILLET * 0.3)) + '" fill="' + shade(top, -0.07) + '"/>' +
        '<path d="' + pathOf(proj(innerOutline(W, D, Rw + G.FILLET), G.T)) + '" fill="' + top + '"/></g>');
      parts.push('<path d="' + pathOf(openTop) + '" fill="none" stroke="' + edge + '" stroke-width="0.6" stroke-linejoin="round"/>');
    }
    return { parts: parts, bb: bbox(sil), n: n, H: H };
  }
  /* ouverture intérieure du rebord (rentrée de dd sur les côtés et l'avant, ouverte côté mur) */
  function innerOutline(W, D, dd) {
    var r = Math.max(G.R - dd, 0.01), pts = [], i, a, seg = 14;
    pts.push([dd, 0]); pts.push([W - dd, 0]);
    for (i = 0; i <= seg; i++) { a = (i / seg) * Math.PI / 2; pts.push([W - G.R + r * Math.cos(a), D - G.R + r * Math.sin(a)]); }
    for (i = 0; i <= seg; i++) { a = Math.PI / 2 + (i / seg) * Math.PI / 2; pts.push([G.R + r * Math.cos(a), D - G.R + r * Math.sin(a)]); }
    return pts;
  }

  /* aperçu (fiche, fenêtre) : étagère posée sur un pegboard vue de trois quarts, cotes,
     cadre à échelle fixe (une 8 × 4 cm paraît petite à côté d'une 33 × 33, comme les fleurs).
     Repère : le milieu de l'arête arrière basse de l'étagère est toujours au même point du cadre. */
  var P34 = projector(VIEW_34);
  var FRAME = (function () {
    var W = G.W_MAX, D = G.D_MAX, pts = [];
    [[0, 0, 22], [W, 0, 22], [0, D, 0], [W, D, 0], [0, D, 22], [W, 0, 0], [-40, D, 0], [W, D + 40, 0]].forEach(function (p) { var q = P34(p[0] - W / 2, p[1], p[2]); pts.push(q); });
    var b = bbox(pts), m = 26, ml = 64; /* à gauche : place pour la cote de profondeur */
    return { x: b[0] - ml, y: b[1] - 70, w: b[2] - b[0] + m + ml, h: b[3] - b[1] + 70 + m };
  })();
  function previewSVG(st, opts) {
    opts = opts || {};
    var lang = opts.lang, L = T(lang), n = normalize(st), F = FRAME, i, j;
    var P = function (x, d, z) { return P34(x - n.w / 2, d, z); };
    var dr = drawing(n, P);
    var ink = "#1d1d1b", mu = "#6b6a66", fs = 13;
    /* pegboard (mur, trame 30 mm) calé sur les goupilles (z = 7,5 mm) */
    var hx0 = holes(n)[0], ct = Math.cos(VIEW_34.yaw * Math.PI / 180), cp = Math.cos(VIEW_34.pitch * Math.PI / 180);
    var board = '<rect x="' + F.x + '" y="' + F.y + '" width="' + F.w + '" height="' + F.h + '" fill="#E6E6E3"/>';
    for (i = -20; i <= 20; i++) for (j = -12; j <= 12; j++) {
      var q = P(hx0 + i * G.PIN, 0, G.HOLE_Z + j * G.PIN);
      if (q[0] < F.x + 5 || q[0] > F.x + F.w - 5 || q[1] < F.y + 5 || q[1] > F.y + F.h - 5) continue;
      board += '<ellipse cx="' + q[0].toFixed(1) + '" cy="' + q[1].toFixed(1) + '" rx="' + (3.1 * ct).toFixed(2) + '" ry="' + (3.1 * cp).toFixed(2) + '" fill="#C9C9C4"/>';
    }
    /* ombre portée sur le mur */
    var sid = "ets" + Math.random().toString(36).slice(2, 8);
    var shp = [P(0, 0, 0), P(n.w, 0, 0), P(n.w + 6, 0, -14 - n.d * 0.06), P(4, 0, -14 - n.d * 0.06)];
    var shadow = '<filter id="' + sid + '" x="-30%" y="-30%" width="160%" height="200%"><feGaussianBlur stdDeviation="5"/></filter>' +
      '<path d="' + pathOf(shp) + '" fill="#000" opacity=".18" filter="url(#' + sid + ')"/>';
    /* cotes : largeur le long de l'avant, profondeur le long du flanc gauche */
    var a0 = P(0, n.d + 14, 0), a1 = P(n.w, n.d + 14, 0), am = P(n.w / 2, n.d + 14, 0);
    var b0 = P(-14, 0, 0), b1 = P(-14, n.d, 0), bm = P(-14, n.d / 2, 0);
    var tick = function (p, dx, dy) { return '<line x1="' + (p[0] - dx) + '" y1="' + (p[1] - dy) + '" x2="' + (p[0] + dx) + '" y2="' + (p[1] + dy) + '"/>'; };
    var dim = '<g font-family="inherit" font-size="' + fs + '" fill="' + ink + '" stroke="' + mu + '" stroke-width="1" stroke-linecap="round">' +
      '<line x1="' + a0[0] + '" y1="' + a0[1] + '" x2="' + a1[0] + '" y2="' + a1[1] + '"/>' + tick(a0, 0, 5) + tick(a1, 0, 5) +
      '<text stroke="none" x="' + am[0].toFixed(1) + '" y="' + (am[1] + fs + 6).toFixed(1) + '" text-anchor="middle" font-weight="600">' + cmTxt(n.w, lang) + " " + L.cm + "</text>" +
      '<line x1="' + b0[0] + '" y1="' + b0[1] + '" x2="' + b1[0] + '" y2="' + b1[1] + '"/>' + tick(b0, 5, 0) + tick(b1, 5, 0) +
      '<text stroke="none" x="' + (bm[0] - 9).toFixed(1) + '" y="' + (bm[1] + 4.5).toFixed(1) + '" text-anchor="end" font-weight="600">' + cmTxt(n.d, lang) + " " + L.cm + "</text></g>";
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + [F.x, F.y, F.w, F.h].map(function (v) { return v.toFixed(1); }).join(" ") + '" role="img" aria-label="' + esc(summary(n, lang)) + '">' +
      board + shadow + dr.parts.join("") + dim + "</svg>";
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* vignette du configurateur de pegboard : à l'échelle (1 unité = 1 mm), largeur du visuel = largeur de l'image.
     Renvoie { src, wmm, hmm, pins } ; pins = fractions (0–1) des 2 goupilles dans l'image (calage sur les trous). */
  var PFRONT = projector(VIEW_FRONT);
  function tile(st) {
    var dr = drawing(st, PFRONT), bb = dr.bb, n = dr.n, P = PFRONT;
    var w = bb[2] - bb[0], h = bb[3] - bb[1];
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + [bb[0], bb[1], w, h].map(function (v) { return v.toFixed(2); }).join(" ") +
      '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '">' + dr.parts.join("") + "</svg>";
    var pins = holes(n).map(function (x) { var p = P(x, 0, G.HOLE_Z); return [(p[0] - bb[0]) / w, (p[1] - bb[1]) / h]; });
    return { src: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg), wmm: w, hmm: h, pins: pins, svg: svg };
  }

  /* icône (bibliothèque du configurateur) : l'étagère seule, vue de trois quarts */
  function icon(st) {
    var n = normalize(st), P = function (x, d, z) { return P34(x - n.w / 2, d, z); }, dr = drawing(n, P), bb = dr.bb, m = 4;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + [bb[0] - m, bb[1] - m, bb[2] - bb[0] + 2 * m, bb[3] - bb[1] + 2 * m].map(function (v) { return v.toFixed(1); }).join(" ") + '">' + dr.parts.join("") + "</svg>";
    return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  }

  /* ================= interface ================= */
  function mount(el, opts) {
    opts = opts || {};
    var doc = el.ownerDocument, lang = normLang(opts.lang || pageLang()), L = T(lang);
    var st = normalize(opts.state || { w: 250, d: 150, rim: false, color: "blanc" });
    var uid = "etag" + Math.random().toString(36).slice(2, 7);
    function num(mm) { var t = (Math.round(mm) / 10).toFixed(1).replace(/\.0$/, ""); return lang === "en" ? t : t.replace(".", ","); }
    function field(k, lbl, lo, hi, v) {
      return '<div class="etag-field"><label class="etag-lbl" for="' + uid + k + '">' + esc(lbl) + '</label>' +
        '<div class="etag-dim"><input type="range" min="' + lo / 10 + '" max="' + hi / 10 + '" step="' + G.STEP / 10 + '" value="' + v / 10 + '" data-r="' + k + '" aria-label="' + esc(lbl) + '">' +
        '<span class="etag-num"><input id="' + uid + k + '" type="text" inputmode="decimal" autocomplete="off" value="' + num(v) + '" data-n="' + k + '"> ' + L.cm + '</span></div>' +
        '<small class="etag-hint">' + esc(fmt(L.range, { a: cmTxt(lo, lang), b: cmTxt(hi, lang) })) + "</small></div>";
    }
    el.innerHTML =
      '<div class="etag-wrap"><div class="etag">' +
        '<div class="etag-preview" data-prev></div>' +
        '<div class="etag-panel">' +
          field("w", L.w, G.W_MIN, G.W_MAX, st.w) +
          field("d", L.d, G.D_MIN, G.D_MAX, st.d) +
          '<div class="etag-field"><span class="etag-lbl">' + esc(L.rim) + '</span><div class="etag-row" role="group" aria-label="' + esc(L.rim) + '">' +
            '<button type="button" data-rim="0">' + esc(L.rimOff) + '</button><button type="button" data-rim="1">' + esc(L.rimOn) + "</button></div></div>" +
          '<div class="etag-field"><span class="etag-lbl">' + esc(L.color) + ' · <b data-cname></b></span><div class="etag-sws" role="radiogroup" aria-label="' + esc(L.color) + '">' +
            PLA.map(function (p) { return '<button type="button" role="radio" class="etag-sw" data-c="' + p[0] + '" title="' + esc(colName(p[0], lang)) + '" aria-label="' + esc(colName(p[0], lang)) + '" style="--c:' + p[2] + '"></button>'; }).join("") +
          "</div></div>" +
          '<p class="etag-meta"><span data-meta></span></p>' +
          '<p class="etag-price" data-price></p>' +
        "</div>" +
      "</div></div>";
    var prevEl = el.querySelector("[data-prev]"), priceEl = el.querySelector("[data-price]"), metaEl = el.querySelector("[data-meta]"), cnameEl = el.querySelector("[data-cname]");
    var raf = 0;
    function render(fromInput) {
      el.querySelectorAll("[data-r]").forEach(function (r) { r.value = st[r.getAttribute("data-r")] / 10; });
      if (fromInput !== "n") el.querySelectorAll("[data-n]").forEach(function (r) { r.value = num(st[r.getAttribute("data-n")]); });
      el.querySelectorAll("[data-rim]").forEach(function (b) { b.setAttribute("aria-pressed", String((b.getAttribute("data-rim") === "1") === st.rim)); });
      el.querySelectorAll("[data-c]").forEach(function (b) { var on = b.getAttribute("data-c") === st.color; b.setAttribute("aria-checked", String(on)); b.tabIndex = on ? 0 : -1; });
      cnameEl.textContent = colName(st.color, lang);
      metaEl.textContent = fmt(L.thick, { t: height(st) }) + " · " + L.pins;
      priceEl.textContent = opts.priceFor ? opts.priceFor(st) : euros(priceCents(st), lang);
      if (!raf) raf = (root.requestAnimationFrame || setTimeout)(function () { raf = 0; prevEl.innerHTML = previewSVG(st, { lang: lang }); });
      if (opts.onChange) opts.onChange(clone(st), true);
    }
    el.addEventListener("input", function (e) {
      var r = e.target.closest("[data-r]"), n = e.target.closest("[data-n]");
      if (r) { var k = r.getAttribute("data-r"); st[k] = snap(parseFloat(r.value) * 10, k === "w" ? G.W_MIN : G.D_MIN, k === "w" ? G.W_MAX : G.D_MAX); render(); }
      else if (n) {
        var k2 = n.getAttribute("data-n"), v = parseFloat(String(n.value).replace(",", "."));
        if (!isFinite(v)) return;
        var lo = k2 === "w" ? G.W_MIN : G.D_MIN, hi = k2 === "w" ? G.W_MAX : G.D_MAX;
        if (v * 10 < lo || v * 10 > hi) return; /* on attend la fin de la saisie (change) */
        st[k2] = snap(v * 10, lo, hi); render("n");
      }
    });
    el.addEventListener("change", function (e) {
      var n = e.target.closest("[data-n]");
      if (!n) return;
      var k = n.getAttribute("data-n"), v = parseFloat(String(n.value).replace(",", "."));
      st[k] = snap((isFinite(v) ? v : st[k] / 10) * 10, k === "w" ? G.W_MIN : G.D_MIN, k === "w" ? G.W_MAX : G.D_MAX);
      render();
    });
    el.addEventListener("click", function (e) {
      var b = e.target.closest("[data-rim]"), c = e.target.closest("[data-c]");
      if (b) { st.rim = b.getAttribute("data-rim") === "1"; render(); }
      if (c) { st.color = c.getAttribute("data-c"); render(); }
    });
    el.querySelector(".etag-sws").addEventListener("keydown", function (e) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!keys[e.key]) return;
      e.preventDefault();
      var i = PLA.findIndex(function (p) { return p[0] === st.color; });
      st.color = PLA[(i + keys[e.key] + PLA.length) % PLA.length][0];
      render(); el.querySelector('[data-c="' + st.color + '"]').focus();
    });
    render();
    return {
      getState: function () { return clone(st); },
      setState: function (s) { st = normalize(s); render(); },
      isValid: function () { return true; },
      refresh: function () { render(); }
    };
  }

  var API = {
    G: G, PLA: PLA, COLORS: PLA.map(function (p) { return p[0]; }), LANGS: LANGS,
    normLang: normLang, colName: colName, normalize: normalize, clone: clone, isValid: isValid,
    encode: encode, decode: decode, holes: holes, holeSpacing: holeSpacing, height: height,
    volume: volume, priceCents: priceCents, euros: euros, unitQty: unitQty, summary: summary,
    previewSVG: previewSVG, tile: tile, icon: icon, mount: mount, label: function (lang) { return T(lang); }
  };
  API.setLogo = function (loops) {
    API.LOGO = loops;
    var a = 0;
    loops.forEach(function (l) { var s = 0, i; for (i = 0; i < l.length; i++) { var p = l[i], q = l[(i + 1) % l.length]; s += p[0] * q[1] - q[0] * p[1]; } a += Math.abs(s) / 2; });
    /* contour du « a » - contre-forme + point */
    var areas = loops.map(function (l) { var s = 0, i; for (i = 0; i < l.length; i++) { var p = l[i], q = l[(i + 1) % l.length]; s += p[0] * q[1] - q[0] * p[1]; } return Math.abs(s) / 2; });
    areas.sort(function (x, y) { return y - x; });
    LOGO_VOL = (areas[0] - areas[1] + (areas[2] || 0)) * G.LOGO_DEPTH;
    initPrice();
  };
  API.setLogo(LOGO);
  root.ETAG = API;
  if (typeof module !== "undefined" && module.exports) module.exports = API;
})(typeof window !== "undefined" ? window : globalThis);
